<template>
    <div id="header" class=" flex jb">
        <div class="slogn flex ac">
            <img src="@/views/objIcon/MJ.png" alt=" " />
            <p>Midjourney中文站-让创意充满无限可能</p>
        </div>
        <div class="menu flex ac">

            <div class="menu_list flex ac lifetime"
                v-if="vip_youhui_header_show&&isLogin&&userInfo.vip_type!=5"
                @click="open_vip">
                <img class="icon2" src="./img/header/vip-icon.gif" alt=" " />
                <p class="fwb">永久会员</p>
                <img class="upgrade" src="./img/header/icon_img12.png" alt="" v-if="header_r_show==1">
                <img class="upgrade" src="./img/header/icon_img13.png" alt="" v-if="header_r_show==2">
            </div>
            <div class="menu_list flex ac" @click="fav_site">
                <img class="icon1" src="./img/header/icon_img3.png" alt=" " />
                <p class="fwb">收藏本站</p>
            </div>
            <!-- handleJump('/member', true) -->
            <div class="menu_list flex ac jb" @click="toNewpay">
                <img class="icon1" src="./img/header/icon_img4.png" alt=" " />
                <p class="fwb">升级会员</p>
            </div>
            <div class="menu_list flex ac users" v-if="isLogin" @mouseover="is_user_box_show=true" @mouseout="is_user_box_show=false">
                <img class="icon1" :src="userInfo.avatarurl ? userInfo.avatarurl : '/img/default-avatar.png'"
                    style="border-radius: 100%;" />
                <p class="fwb">{{ userInfo.nickname }}</p>
                <div class="user_info" v-show="is_user_box_show">
                    <div class="info flex jb ac">
                        <div class="avatar flex ac">
                            <img :src="userInfo.avatarurl ? userInfo.avatarurl : '/img/default-avatar.png'" />
                            <div class="name">
                                <p class="nick_name">{{ userInfo.nickname }}</p>
                                <p class="uid">ID:{{ userInfo.uid }}</p>
                            </div>
                        </div>
                        <p class="more" @click="show_userInfo">个人资料 ></p>
                    </div>
                    <div class="member flex jb ac">
                        <div class="item">
                            <p>{{ userInfo.score_balance }}</p>
                            <p class="desc">可用积分</p>
                            <!-- <p class="desc"  @click="handleJump('/inventory', true)">可用积分 ></p> -->
                        </div>
                        <div class="item">
                            <p>{{ userInfo.vip_end_date }}</p>
                            <p class="desc">会员到期时间</p>
                        </div>
                    </div>
                    <div class="open flex jb ac">
                        <div class="tips">
                            <strong>开通会员，尊享会员特权</strong>
                            <p>升级更高等级会员，享折上折!</p>
                        </div>
                        <span @click="handleOpen">开通</span>
                    </div>
                    <div class="menu flex jb">
                        <div class="item" v-for="(item, index) in user_menu_list" @click="handleClickMenu(index)"
                            :key="index">
                            <template v-if="index == 1 || index == 3">
                                <el-popover placement="left" popper-class="kefu_pop" width="460" trigger="hover">
                                    <div class="kefuBox" @mouseover="is_user_box_show=true" @mouseout="is_user_box_show=false">
                                        <img class="kefuLef" src="./img/kfnImg.webp"></img>
                                        <div class="kefuRigbox">
                                            <div class="kefuTitText">客服在线</div>
                                            <div class="kefuTimeTip">
                                                客服在线时间：上午8:30-11:30，下午14:00-18:00
                                            </div>
                                            <div
                                                :class="isOnline == '在线' ? 'kefuTimeCur animated-yes' : 'kefuTimeCur animated-no'">
                                                当前人工客服{{ isOnline }}，{{ isOnline == '在线' ? '有问题请' : '请稍后咨询或去' }}→ <div
                                                    class="tokefuBtn" @click="toKf">{{ isOnline == '在线' ? '人工客服' : '留言' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" @mouseover="checkOnlineStatus">
                                        <img :src="item.icon" />
                                        <p>
                                            {{ item.text }}
                                        </p>
                                    </div>
                                </el-popover>
                                <!-- </a> -->
                            </template>
                            <template v-else>
                                <img :src="item.icon" />
                                <p>
                                    {{ item.text }}
                                </p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="menu_list flex ac no_login" v-else @click="handleLogin">
                <img class="icon1" src="./img/default-avatar.png" alt=" " />
                <p>未登录</p>
            </div>
            <!--          <loginPanel ref="loginPanel"></loginPanel>-->
        </div>

    </div>
</template>
<script type="text/javascript">
import loginPanel from "COMPONENTS/LoginPanel.vue"
import utils from '@/utils/index.js'

export default {
    components: {
        loginPanel
    },
    created() {
        this.payPopCheck()
    },
    data() {
        return {
            user_menu_list: [
                {
                    icon: require('./img/header/icon_img6.png'),
                    text: '我的作品',
                    path: '/user/collection'
                },
                {
                    icon: require('./img/header/icon_img7.png'),
                    text: '联系客服',
                    path: '/user/collection'
                },
                {
                    icon: require('./img/header/icon_img8.png'),
                    text: '激活码兑换',
                    path: '/user/collection'
                },
                {
                    icon: require('./img/header/icon_img9.png'),
                    text: '问题与反馈',
                    path: '/user/collection'
                },
                {
                    icon: require('./img/header/icon_img10.png'),
                    text: '每日签到',
                    path: '/user/collection'
                },
                {
                    icon: require('./img/header/icon_img11.png'),
                    text: '退出登录',
                    path: '/user/collection'
                },
            ],
            isOnline:'在线',
            is_user_box_show:false,
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        isLogin() {
            return this.$store.state.isLogin;
        },
        show_vip_time() {
            return this.$store.state.show_vip_time;
        },
        header_r_show() {
            return this.$store.state.header_r_show;
        },
        vip_youhui_header_show() {
            return this.$store.state.vip_youhui_header_show;
        },
    },
    methods: {
        toNewpay(){
            if (!this.isLogin) {
                this.handleLogin();
                return
            }
            this.$store.commit('setisPayPopShow', true)
        },
        toKf() {
            // window.open(SITE_BTN_CONFIG.kefu_url.btn_value)
            utils.openKefu();
        },
        checkOnlineStatus() {
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const totalMinutes = hours * 60 + minutes;

            // 时间范围配置（分钟数计算）
            const morningStart = 8 * 60 + 30;   // 08:30 → 510
            const morningEnd = 11 * 60 + 30;    // 11:30 → 690
            const afternoonStart = 14 * 60;     // 14:00 → 840
            const afternoonEnd = 18 * 60;       // 18:00 → 1080

            // 判断当前是否在时间范围内
            const isOnlines = (totalMinutes >= morningStart && totalMinutes <= morningEnd) ||
                (totalMinutes >= afternoonStart && totalMinutes <= afternoonEnd);

            this.isOnline = isOnlines ? '在线' : '不在线';
        },
        payPopCheck() {
            const vipForever = localStorage.getItem("vip_time") || 0;
            if (vipForever == 0) {
                console.log('===0')
                this.$store.commit('showVipTime', false)
            } else {
                console.log('!!!0')
                let kehuInfo = localStorage.getItem('vip_time')
                kehuInfo = JSON.parse(kehuInfo)
                let start_time = kehuInfo
                const TWELVE_HOURS = 24 * 60 * 60 * 1000; // 24小时的毫秒数
                const currentTime = Date.now();

                // 计算时间差
                const timeDiff = currentTime - parseInt(start_time, 10);

                // 超过24小时执行操作
                if (timeDiff >= TWELVE_HOURS) {
                    this.$store.commit('showVipTime', false)
                } else {
                    this.$store.commit('showVipTime', true)
                }
            }
        },
        open_vip() {
            if (this.header_r_show==1) {
                this.$store.commit('setisPayPopShow', true)
            } else if(this.header_r_show==2) {
                // this.$emit('showPayPop')
                //显示挽留支付弹框
                this.$emit('newOpen_vip')
            } else {
                this.$store.commit("setisPayPopShow", true);
            }
        },
        show_userInfo() {
            this.$store.commit('setShowUserInfo', true)
        },
        handleClickMenu(index) {

            if (index == 0) {
                this.handleJump('/favorites', true)
            }
            if (index == 1) {
                // this.handleJump('/contact', true)
            }
            if (index == 2) {
                this.$store.commit('setShowCodeExchange', true)
                return
            }
            if (index == 3) {
                return
            }
            if (index == 4) {
                this.$store.commit('setShowAttenDance', true)
            }
            if (index == 5) {
                this.$confirm('确定要退出当前账号?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    localStorage.clear();
                    this.$store.commit('setUserInfo', null)
                    this.$store.commit('setIsLogin', false)
                    this.$store.commit('setVipYouhuiHeaderShow',false)
                    // 推出跳转大厅
                    this.$router.push('/square')
                }).catch(() => {
                });
            }
        },
        handleJump(str, needLogin) {
            if (!this.isLogin && needLogin) {
                this.handleLogin();
                return;
            }
            this.$router.push(str)
        },
        window_open(url) {
            window.open(url)
        },
        handleLogin() {
            // this.$refs.loginPanel.show()
            this.$store.commit('setShowLogin', true)
            // this.$store.commit('setShowLogin', true)
        },
        handleOpen() {
            // this.$store.commit('setShowOpen', true)
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
        },
        //收藏站点
        fav_site() {
            let that = this
            deferredPrompt.prompt()
            deferredPrompt.userChoice.then(function (e) {
                let user_id = localStorage.getItem("user_id") || 0;
                if (e.outcome === 'dismissed') {
                    // 不允许 //埋点
                    that.$http.post('/wap/jsstat/browser/record/', { user_id: user_id, mod_code: "pwacancel", site_url: MAIN_URLROOT })
                } else {
                    // 允许 //埋点
                    that.$http.post('/wap/jsstat/browser/record/', { user_id: user_id, mod_code: "pwaadd", site_url: MAIN_URLROOT })
                }
            })
        },
      // ceshiBtn(){
      //   this.$store.commit('setShow_Continue', true)
      // },
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#header {
    padding: 0 10px;
    position: relative;
    z-index: 99;
    height: 40px;

    .slogn {
        padding: 10px 0;

        img {
            width: 16px;
            height: 16px;
            border-radius: 2px;
            margin-right: 5px;
        }

        p {
            font-size: 14px;
            font-weight: bold;
        }
    }

    .menu {
        .menu_list {
            padding: 10px 3px;
            margin: 0 3px;
            cursor: pointer;

            // img {
            //     width: 15px;
            //     height: 15px;
            //     margin-right: 5px;
            // }
            p {
                color: #fff;

                font-size: 14px;
            }

            .icon1 {
                width: 15px;
                height: 15px;
                margin-right: 5px;
                border-radius: 50%;
                overflow: hidden;
            }

            .icon2 {
                width: 24px;
                height: auto
            }

            &.jb {
                padding: 3px 10px;
                border-radius: 4px;
                //background-color: #d026fe;
                //background: -o-linear-gradient(left, #d026fe 0%, #6e30ce 100%);
                //background: -ms-linear-gradient(left, #d026fe 0%, #6e30ce 100%);
                //background: linear-gradient(left, #d026fe 0%, #6e30ce 100%);
                //background: -moz-linear-gradient(left,
                //        #d026fe 0%,
                //        #6e30ce 100%);
                //background: -webkit-linear-gradient(left,
                //        #d026fe 0%,
                //        #6e30ce 100%);
              background: linear-gradient(to right, #d026fe, #6e30ce);
            }

            &.users {
                img {
                    width: 28px;
                    height: 28px;
                }

                p {
                    max-width: 100px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                // &:hover {
                //     .user_info {
                //         display: block;
                //     }
                // }
            }

            &.no_login {
                img {
                    width: 30px;
                    height: 30px;
                }

                p {
                    font-weight: bold;
                }
            }
        }
    }

    .user_info {
        // display: none;
        position: absolute;
        right: 10px;
        top: 40px;
        background: #1e1f22;
        min-width: 150px;
        max-width: 320px;
        border-radius: 5px;
        padding: 20px;

        &:before {
            content: "";
            position: absolute;
            top: -8px;
            right: 40px;
            width: 0;
            height: 0;
            border-right: 8px solid transparent;
            border-left: 8px solid transparent;
            border-bottom: 8px solid #1e1f22;
            border-radius: 2px;
        }

        .info {
            width: 100%;
            padding-bottom: 20px;
            border-bottom: 1px solid #d8d8d838;

            .avatar {
                img {
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    border-radius: 100%;
                    overflow: hidden;
                }
            }

            .more {
                font-size: 14px;
                color: #fff;
                cursor: pointer;
            }

            .name {
                .nick_name {
                    color: #fff;
                    font-size: 14px;
                    margin-bottom: 5px;
                }

                .uid {
                    color: #6c6c6c;
                    font-size: 12px;
                }
            }
        }

        .member {
            width: 100%;
            margin: 20px 0;
            padding: 0 30px;

            .item {
                p {
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                }

                .desc {
                    color: #939393;
                    margin-top: 5px;
                    font-size: 14px;
                }

                &:first-child {
                    .desc {
                        cursor: pointer;

                        &:hover {
                            color: #ccc;
                        }
                    }
                }
            }
        }

        .open {
            padding: 5px 20px;
            border-radius: 10px;
            //background-color: #d026fe;
            //background: -o-linear-gradient(left, #d026fe 0%, #6e30ce 100%);
            //background: -ms-linear-gradient(left, #d026fe 0%, #6e30ce 100%);
            //background: linear-gradient(left, #d026fe 0%, #6e30ce 100%);
            //background: -moz-linear-gradient(left, #d026fe 0%, #6e30ce 100%);
            //background: -webkit-linear-gradient(left, #d026fe 0%, #6e30ce 100%);
          background: linear-gradient(to right, #d026fe, #6e30ce);
            .tips {
                strong {
                    font-size: 14px;
                    font-weight: bold;
                    color: #fff;
                }

                p {
                    font-size: 12px;
                    color: #fff;
                }
            }

            span {
                background: #fff;
                height: 24px;
                line-height: 24px;
                cursor: pointer;
                color: #000;
                border-radius: 12px;
                font-size: 12px;
                padding: 0 12px;
                margin-left: 20px;
            }
        }

        .menu {
            margin-top: 20px;
            flex-wrap: wrap;

            .item {
                width: 74px;
                padding: 10px 0;
                border-radius: 5px;
                cursor: pointer;

                img {
                    display: block;
                    width: 20px;
                    height: 20px;
                    margin: 0 auto 10px;
                }

                p {
                    font-size: 12px;
                    color: #939393;
                    text-align: center;
                }

                &:hover {
                    background: #2e3037;
                }
            }
        }
    }

    .lifetime {
        position: relative;


        .upgrade {
            position: absolute;
            right: -33px;
            top: 34px;
            min-width: 240px;
            animation: bounce 4s infinite;
            /* 应用动画 */

        }
    }
}

@keyframes bounce {
    0% {
        transform: translate3d(0px, 0px, 0px);
    }

    3% {
        transform: translate3d(0px, -3px, 0px);
    }

    6% {
        transform: translate3d(0px, 3px, 0px);
    }

    9% {
        transform: translate3d(0px, -3px, 0px);
    }

    12% {
        transform: translate3d(0px, 3px, 0px);
    }

    15% {
        transform: translate3d(0px, -3px, 0px);
    }

    18% {
        transform: translate3d(0px, 3px, 0px);
    }

    21% {
        transform: translate3d(0px, -3px, 0px);
    }

    24% {
        transform: translate3d(0px, 0px, 0px);
    }

    100% {
        transform: translate3d(0px, 0px, 0px);
    }
}

.kefuBox {
    display: flex;
    align-items: center;
    padding: 10px;
    .kefuLef {
        width: 100px;
        height: 100px;
    }

    .kefuRigbox {
        margin-left: 20px;

        .kefuTitText {
            font-size: 20px;
            font-weight: 600;
            color: #000;
        }

        .kefuTimeTip {
            color: #000;
            margin-top: 10px;
        }

        .kefuTimeCur {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #000;
            margin-top: 10px;

            .tokefuBtn {
                border-radius: 6px;
                background: #000;
                color: #fff;
                font-size: 14px;
                padding: 5px 10px;
                cursor: pointer;
            }
        }
    }

    .animated-yes {
        animation: colorChange 1s infinite;
    }

    .animated-no {
        animation: colorChangeNo 1s infinite;
    }
}

@keyframes colorChange {
    0% {
        color: #07c160;
    }

    100% {
        color: #fff;
    }
}

@keyframes colorChangeNo {
    0% {
        color: #ec3b3b;
    }

    100% {
        color: #fff;
    }
}
.kefu_pop {
    margin-right: 0 !important;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1) !important;
    border-color: transparent !important;
}
</style>

<style>
.kefu_pop {
    border-color: transparent !important;
}
</style>